import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from '@sm/wds-react';
import { LanguageListLO } from './LanguageMenu';
import { AnonFooterLinks } from './FooterLinks';
import TrusteSeals from './TrusteSeals';
import CopyRight from './CopyRight';

import './footer.scss';

const AnonFooter = ({ domain, lang, country, variant, isEUDC, tld }) => {
  const TrusteFooterSeals = () => {
    return (
      <Col md={5} className="wds-flex  wds-flex--y-center  wds-flex--x-end">
        <TrusteSeals
          lang={lang}
          country={country}
          isUserAuthenticated={false}
          isEUDC={isEUDC}
        />
      </Col>
    );
  };
  return (
    <div className="sm-footer sm-footer__anon">
      <Grid>
        <Choose>
          <When condition={variant === 'default'}>
            <>
              <Row>
                <Col>
                  <div className="sm-footer--border">
                    <AnonFooterLinks
                      domain={domain}
                      country={country}
                      lang={lang}
                      variant={variant}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="sm-footer--border wds-p-t-4">
                    <LanguageListLO domain={domain} tld={tld} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={7} className="wds-flex  wds-flex--y-center">
                  <div className="wds-flex__item">
                    <CopyRight />
                  </div>
                </Col>
                {TrusteFooterSeals()}
              </Row>
            </>
          </When>
          <Otherwise>
            <Row>
              <Col md={7} className="wds-flex wds-flex--y-center">
                <div className="wds-flex__item">
                  <AnonFooterLinks lang={lang} variant={variant} />
                  <CopyRight />
                </div>
              </Col>
              {TrusteFooterSeals()}
            </Row>
          </Otherwise>
        </Choose>
      </Grid>
    </div>
  );
};

AnonFooter.propTypes = {
  domain: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['default', 'slim']),
  isEUDC: PropTypes.bool,
  tld: PropTypes.string.isRequired
};

AnonFooter.defaultProps = {
  variant: 'default',
  isEUDC: false
};

export default AnonFooter;
